import { joinNonEmptyStrings } from '@utils'

export const getSurveyLabel = ({ title, uniqueDescriptor }) =>
  joinNonEmptyStrings(' | ', title, uniqueDescriptor)

export const createDetailPath = (id) => `/surveys/${id}`
